import React from "react";
import Slider from "react-slick";

function ReviewSlider() {
  const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "60px",
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider {...settings}>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[94%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Being a part of VNI has been an amazing experience! The networking opportunities, business collaborations, and professional growth have been truly rewarding. It's a community that values trust, transparency, and success for all 
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Ashok Dabral
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Engineering Solutions, India

                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            VNI has provided me with a strong platform to connect with like-minded professionals and expand my business effortlessly. The supportive environment and structured networking make it a must-join for entrepreneurs
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Gautam Anand

                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Coaching, India
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            VNI is more than just a business network; it's a family of professionals helping each other grow. The positive atmosphere, business referrals, and learning opportunities have significantly boosted my confidence and success.
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Aankuur Bhogia
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Sales, United States
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Joining VNI was the best decision for my business! The structured networking, genuine business connections, and growth-oriented environment make it stand out from the rest. Highly recommended!
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Jeewan Chandra
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Digital Marketing, India
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            At VNI, I found not just business opportunities but also lifelong connections. The transparency and ethical approach to networking make it a trustworthy and valuable platform for entrepreneurs. 
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Mukesh Gupta
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Real Estate, Australia
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </>
  );
}

export default ReviewSlider;
